module.exports = __webpack_public_path__ + "img/svg/isotipo.fa5fd72d15c8c2b9017874bbc7954758.svg";